module.exports = __webpack_public_path__ + "img/PD1502551859536248832.552b9daf.png";